import { render, staticRenderFns } from "./CompanyConfiguration.vue?vue&type=template&id=613c7278&scoped=true"
import script from "./CompanyConfiguration.vue?vue&type=script&lang=ts"
export * from "./CompanyConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613c7278",
  null
  
)

export default component.exports